import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module media-embed/mediaembedtoolbar
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { WidgetToolbarRepository } from 'ckeditor5/src/widget.js';
import { getSelectedMediaViewWidget } from './utils.js';
import './mediaembedconfig.js';
/**
 * The media embed toolbar plugin. It creates a toolbar for media embed that shows up when the media element is selected.
 *
 * Instances of toolbar components (e.g. buttons) are created based on the
 * {@link module:media-embed/mediaembedconfig~MediaEmbedConfig#toolbar `media.toolbar` configuration option}.
 */
var MediaEmbedToolbar = /*#__PURE__*/function (_Plugin) {
  _inherits(MediaEmbedToolbar, _Plugin);
  var _super = _createSuper(MediaEmbedToolbar);
  function MediaEmbedToolbar() {
    _classCallCheck(this, MediaEmbedToolbar);
    return _super.apply(this, arguments);
  }
  _createClass(MediaEmbedToolbar, [{
    key: "afterInit",
    value:
    /**
     * @inheritDoc
     */
    function afterInit() {
      var editor = this.editor;
      var t = editor.t;
      var widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
      widgetToolbarRepository.register('mediaEmbed', {
        ariaLabel: t('Media toolbar'),
        items: editor.config.get('mediaEmbed.toolbar') || [],
        getRelatedElement: getSelectedMediaViewWidget
      });
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [WidgetToolbarRepository];
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "pluginName",
    get: function get() {
      return 'MediaEmbedToolbar';
    }
  }]);
  return MediaEmbedToolbar;
}(Plugin);
export { MediaEmbedToolbar as default };